export const EMPTY_APP = 'App/EMPTY_APP';
export const UPDATE_TITLE = 'App/UPDATE_TITLE';

export const OPEN_MODAL = 'App/OPEN_MODAL';
export const CLOSE_MODAL = 'App/CLOSE_MODAL';

export const OPEN_CONFIRM_MODAL = 'App/OPEN_CONFIRM_MODAL';
export const CLOSE_CONFIRM_MODAL = 'App/CLOSE_CONFIRM_MODAL';

export const OPEN_PREVIEW_MODAL = 'App/OPEN_PREVIEW_MODAL';
export const CLOSE_PREVIEW_MODAL = 'App/CLOSE_PREVIEW_MODAL';



// WEBPACK FOOTER //
// ./src/containers/App/store/constants.js